
import Vue from 'vue'
import {
  VAppBarNavIcon,
  VAppBarTitle,
  VBtn,
  VDivider,
  VIcon,
  VList,
  VListItem,
  VListItemGroup,
  VListItemIcon,
  VNavigationDrawer,
  VSpacer,
  VToolbar,
} from 'vuetify/lib'
import JcdcUtilityMenuFooter from '@/components/jcdc/JcdcUtilityMenuFooter.vue'
import JcdcUtilityMenuLinks from '@/components/jcdc/JcdcUtilityMenuLinks.vue'
import JcdcNavRouterMobileMenu from '@/components/jcdc/JcdcNavRouterMobileMenu.vue'

import {
  filteredMenu,
  navList,
  userInfo,
  utilityItem,
} from '@/util/navUtilities'

import { formatDisplayDateTime } from '@/util/formatters'

export default Vue.extend({
  name: 'JcdcNavRouterMobile',
  components: {
    JcdcUtilityMenuFooter,
    JcdcUtilityMenuLinks,
    JcdcNavRouterMobileMenu,
    VAppBarNavIcon,
    VAppBarTitle,
    VBtn,
    VDivider,
    VIcon,
    VList,
    VListItem,
    VListItemGroup,
    VListItemIcon,
    VNavigationDrawer,
    VSpacer,
    VToolbar,
  },
  props: {
    navList: { type: Array as () => navList[], required: true },
    appTitle: { type: String, required: true },
    infoDate: { type: [String, Date, Number, Object], default: undefined },
    // Utility Menu
    userInfo: { type: Object as () => userInfo, required: true },
    utilityList: { type: Array as () => utilityItem[], default: (): [] => [] },
    // Testing
    navTest: { type: Boolean, default: false }, // For Testing
    utilTest: { type: Boolean, default: false }, // For Testing
    titleTest: { type: Boolean, default: false }, // For Testing
    routeTest: { type: Array as () => string[], default: (): [] => [] }, // For Testing
  },
  data() {
    return {
      openNav: this.navTest,
      openUtil: this.utilTest,
      navPosition: 80,
      activeNavList: this.navList,
      parentNavItem: '',
      selection: undefined,
    }
  },
  computed: {
    attachId() {
      return `_${Math.random().toString(36).substr(2, 9)}`
    },
  },
  created() {
    window.addEventListener('scroll', this.handleScroll)
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  mounted() {
    if (process.env.NODE_ENV == 'storybook' && this.titleTest) {
      this.navPosition = 0
    }
  },
  methods: {
    filteredMenu,
    formatDisplayDateTime,
    handleScroll() {
      const element = this.$refs['mobileNav'] as HTMLElement
      this.navPosition = element.getBoundingClientRect().top
    },
    displayChildNav(item) {
      this.parentNavItem = item.name
      this.activeNavList = item.children
    },
  },
})
